/* eslint-disable no-undef */
import { genericService } from "shared/GenericService";

const BASE_URL = "api/report/";
const InitActionCreator = ({ baseUrl, method }) => {
	return ({ type, endPoint, data, responseType, params, meta, headers }) => ({
		type,
		request: {
			url: baseUrl + endPoint,
			method,
			data,
			responseType,
		},
		headers,
		meta,
		params,
	});
};
const createPostAction = InitActionCreator({ baseUrl: BASE_URL, method: "POST" });

export const prepareAndGetPdfExport = ({ dashboardName, filters, fileName, width, height, ...props }) => {
	genericService({
		...props,
		action: createPostAction({
			type: "GET_PDF_EXPORT_DASHBOARD",
			endPoint: "prepareAndGetPdfExport",
			data: {
				dashboardName,
				filters,
				width,
				height,
			},
			responseType: "blob",
		}),
		displayToast: "EXPORT",
		onSuccess: (data) => {
			var fileDownload = require("js-file-download");
			fileDownload(data, fileName + ".pdf");
		},
		onFailed: (error) => {
			if (error) throw error;
		},
	});
};
